import { Component, inject, input } from '@angular/core';

import { IndexPage } from '../../model/index-page';
import { SeoService } from '../../service/seo.service';
import { CategoriesComponent } from '../layout/categories.component';
import { ShippingComponent } from '../layout/shipping.component';
import { ProductItemComponent } from '../product/product-item.component';
import { CoverSliderComponent } from '../slider/cover-slider.component';
import { ProductSliderComponent } from '../slider/product-slider.component';

@Component({
  selector: 'index-page',
  imports: [
    CategoriesComponent, ShippingComponent, ProductItemComponent, CoverSliderComponent,
    ProductSliderComponent
  ],
  host: {
    style: 'display: contents'
  },
  template: `
    <!-- Slide1 -->
    <section class="slide1">
      <cover-slider [covers]="data().covers" />
    </section>

    <categories />

    <!-- New Products -->
    <section class="newproduct bgwhite p-t-45 p-b-105">
      <div class="container">
        <div class="sec-title p-b-60">
          <h3 class="m-text5 t-center">
            Новинки
          </h3>
        </div>
        <!-- Slide2 -->
        <product-slider>
          @for (product of data().populars; track product.id) {
            <div class="item-slick2 p-l-15 p-r-15">
              <product-item [product]="product" />
            </div>
          }
        </product-slider>
      </div>
    </section>

    <shipping />
    `
})
export class IndexPageComponent {

  readonly data = input.required<IndexPage>();

  constructor() {
    inject(SeoService).page(this.data);
  }

}
